module.exports = __webpack_public_path__ + "static/media/pp_regular_paper_straw_green1.e825f025.png";